<div class="modal-content p-3">
    <div class="modal-body">

        <div class="row">
            <div class="col-sm-12">
                <button class="close mr-4 mt-4" type="button" (click)="close()"><i class="fa fa-times"></i></button>
            </div>

            <div class="col-sm-12 mt-3" id="print-section">
                <div class="row w-100 mx-auto max-height" *ngIf="inputModel">
                    <div class="col-sm-12 d-flex justify-content-end no-print" *ngIf="inputModel?.link && objectKeys(inputModel?.link).length > 0">
                        <span class="color-primary text-nowrap" [ngClass]="{'cursor-pointer': inputModel?.link?.url}" (click)="goToUrl(inputModel?.link?.url)">
                            {{inputModel?.link?.texto || ''}} <ng-container *ngTemplateOutlet="iconoTemplate; context: { $implicit: {iconoCode: inputModel?.link?.icono, classHtml: 'ml-2' }}"></ng-container>
                        </span>
                    </div>
    
                    <div class="col-sm-12" *ngIf="inputModel?.titulo">
                        <div class="d-flex flex-column mb-3 mb-md-0">
                            <div class="d-flex align-items-center">
                                <ng-container *ngTemplateOutlet="iconoTemplate; context: { $implicit: {iconoCode: ' assignment_turned_in', classHtml: 'color-primary mr-3' }}"></ng-container>
                                <span class="color-on-primary-container font-weight-bold" style="font-size: 2rem !important;">
                                    {{inputModel?.titulo}}
                                </span>
                            </div>
                            <div class="mt-2" *ngIf="inputModel?.subtitulo">
                                <span class="font-italic" style="color: #001D35">
                                    {{inputModel?.subtitulo}}
                                </span>
                            </div>
                        </div>
                    </div>
    
                    <div class="row w-100 mx-auto my-4" *ngIf="inputModel?.secciones && inputModel?.secciones.length > 0">
                        <ng-container *ngFor="let seccion of inputModel?.secciones">
    
                            <div class="col-sm-12 mt-2" *ngIf="seccion?.titulo">
                                <mat-chip class="chip-info mr-2"><i class="fa fa-info" aria-hidden="true"></i></mat-chip>
                                <strong class="color-on-primary-container" style="font-size: 1.7rem;">{{seccion?.titulo}}</strong>
                            </div>
    
                            <ng-container *ngIf="seccion?.elementos && seccion?.elementos.length > 0">
                                <ng-container *ngFor="let element of seccion?.elementos">
                                    <div class="col-sm-12 col-md-6 my-2">
                                        <div class="row w-100 mx-auto">
                                            <div class="col-sm-12" *ngIf="element?.titulo">
                                                <p class="color-on-primary-fixed-variant">
                                                    <ng-container *ngTemplateOutlet="iconoTemplate; context: { $implicit: {iconoCode: element?.iconoTitulo, classHtml: 'mr-2' }}"></ng-container> {{element?.titulo}}
                                                </p>
                                            </div>
                                            <div class="col-sm-12">
                                                <p class="color-on-primary-fixed-variant pl-4" style="font-weight: 500;">
                                                    <ng-container *ngTemplateOutlet="valueTemplate; context: { $implicit: {type: element?.tipo, valor: element?.value }}"></ng-container>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                            </ng-container>

                            <div class="col-sm-12 mt-3 mb-5" *ngIf="seccion?.lista?.elementosLista && seccion?.lista?.elementosLista.length > 0">
                                <div class="table-responsive">
                                    <table mat-table [dataSource]="seccion?.lista?.elementosLista" class="border">
                                        <ng-container matColumnDef="producto">
                                            <th mat-header-cell *matHeaderCellDef class="primary-container font-weight-bold"> Poducto / Servicio </th>
                                            <td mat-cell *matCellDef="let element"> {{element.producto}} </td>
                                            <td mat-footer-cell *matFooterCellDef class="primary-container font-weight-bold"> Total neto </td>
                                        </ng-container>
                                        <ng-container matColumnDef="cantidad">
                                            <th mat-header-cell *matHeaderCellDef class="primary-container font-weight-bold"> Cantidad </th>
                                            <td mat-cell *matCellDef="let element" class="text-right"> 
                                                {{element.cantidad || element.cantidad == 0 ? (element.cantidad | number: '1.0-0' ) : ''}}
                                            </td>
                                            <td mat-footer-cell *matFooterCellDef class="primary-container font-weight-bold">  </td>
                                        </ng-container>
                                        <ng-container matColumnDef="precioUnitario">
                                            <th mat-header-cell *matHeaderCellDef class="primary-container font-weight-bold"> Monto </th>
                                            <td mat-cell *matCellDef="let element" class="text-right"> 
                                                {{element.precioUnitario || element.precioUnitario == 0 ? ('$' + (element.precioUnitario | number: '1.0-0' )) : ''}}
                                            </td>
                                            <td mat-footer-cell *matFooterCellDef class="primary-container font-weight-bold">  </td>
                                        </ng-container>
                                        <ng-container matColumnDef="total">
                                            <th mat-header-cell *matHeaderCellDef class="primary-container font-weight-bold"> Total </th>
                                            <td mat-cell *matCellDef="let element" class="text-right"> 
                                                {{element.total || element.total == 0 ? ('$' + (element.total | number: '1.0-0' )) : ''}}
                                            </td>
                                            <td mat-footer-cell *matFooterCellDef class="primary-container font-weight-bold text-right"> 
                                                {{seccion?.lista?.totalLista || seccion?.lista?.totalLista == 0 ? ('$' + (seccion?.lista?.totalLista | number: '1.0-0' )) : ''}}
                                            </td>
                                        </ng-container>

                                        <tr mat-header-row *matHeaderRowDef="['producto', 'cantidad', 'precioUnitario', 'total']" class="border"></tr>
                                        <tr mat-row *matRowDef="let row; columns: ['producto', 'cantidad', 'precioUnitario', 'total'];" class="border"></tr>
                                        <tr mat-footer-row *matFooterRowDef="['producto', 'cantidad', 'precioUnitario', 'total']" class="border"></tr>
                                    </table>
                                </div>
                            </div>
                            
                        </ng-container>
                    </div>
    
                    <div class="col-sm-12 d-flex justify-content-center" *ngIf="inputModel?.botonDescarga === true">
                        <button mat-fab extended 
                            class="custom-button-secondary shadow-none no-print"
                            [printTitle]='(inputModel?.nombreDescarga || inputModel?.titulo || "")+"_"+today'
                            [useExistingCss]="true"
                            printSectionId="print-section"
                            ngxPrint
                        >
                            <mat-icon 
                                aria-hidden="false" 
                                aria-label="Icono descargar" 
                                fontIcon="download" 
                                class="icon-download"
                            ></mat-icon>
                            Descargar
                        </button>
                    </div>
    
                </div>
            </div>

        </div>

    </div>
</div>

<ng-template #iconoTemplate let-elemento>
    <ng-container *ngIf="elemento?.iconoCode">
        <ng-container *ngIf="isMaterialIcon(elemento?.iconoCode); else elseTemplate">
            <mat-icon [ngClass]="[elemento?.classHtml || '']">{{elemento?.iconoCode}}</mat-icon>
        </ng-container>
        <ng-template #elseTemplate>
            <i [ngClass]="[elemento?.iconoCode || '', elemento?.classHtml || '']" aria-hidden="true"></i>
        </ng-template>
    </ng-container>
</ng-template>

<ng-template #valueTemplate let-elemento>

    <ng-container [ngSwitch]="elemento?.type">
        <ng-container *ngSwitchCase="'numero-entero'">
            {{elemento?.valor || elemento?.valor == 0 ? (elemento?.valor | number: '1.0-0' ) : ''}}
        </ng-container>
        <ng-container *ngSwitchCase="'numero-entero-pesos'">
            {{elemento?.valor || elemento?.valor == '0' ? '$' : ''}}{{elemento?.valor || elemento?.valor == 0 ? (elemento?.valor | number: '1.0-0' ) : ''}}
        </ng-container>
        <ng-container *ngSwitchCase="'fecha'">
            {{elemento?.valor ? (elemento?.valor | date: 'dd-MM-yyyy' : 'UTC') : ''}}
        </ng-container>
        <ng-container *ngSwitchCase="'rut'">
            {{elemento?.valor ? (elemento?.valor | rutFormat) : ''}}
        </ng-container>
        <ng-container *ngSwitchCase="'estado'">
            <ng-container *ngIf="inputModel?.tipo == 'orden'; else elseTipoTemplate">
                <ng-container *ngTemplateOutlet="estadoOrdenesTemplate; context: { $implicit: elemento?.valor}"></ng-container>
            </ng-container>
            <ng-template #elseTipoTemplate>
                <ng-container *ngTemplateOutlet="estadoLicitacionesTemplate; context: { $implicit: elemento?.valor}"></ng-container>
            </ng-template>
        </ng-container>
        <ng-container *ngSwitchDefault>
            {{elemento?.valor}}
        </ng-container>
    </ng-container>
    
</ng-template>

<ng-template #estadoLicitacionesTemplate let-elemento>

    <ng-container [ngSwitch]="elemento">
        <ng-container *ngSwitchCase="'Publicada'">
            <span class="py-2 px-3 span-primary-state text-nowrap">
                <i class="fa fa-cloud-upload color-primary mr-2 font-size-icon" aria-hidden="true"></i> Publicada
            </span>
        </ng-container>
        <ng-container *ngSwitchCase="'Cerrada'">
            <span class="py-2 px-3 span-warning-state text-nowrap">
                <i class="fa fa-lock color-warning mr-2 font-size-icon" aria-hidden="true"></i> Cerrada
            </span>
        </ng-container>
        <ng-container *ngSwitchCase="'Desierta (o art. 3 ó 9 Ley 19.886)'">
            <span class="py-2 px-3 span-outline-state text-nowrap">
                <i class="fa fa-minus color-outline mr-2" aria-hidden="true"></i> Desierta (o art. 3 ó 9 Ley 19.886)
            </span>
        </ng-container>
        <ng-container *ngSwitchCase="'Desierta'">
            <span class="py-2 px-3 span-outline-state text-nowrap">
                <i class="fa fa-minus color-outline mr-2" aria-hidden="true"></i> Desierta
            </span>
        </ng-container>
        <ng-container *ngSwitchCase="'Adjudicada'">
            <span class="py-2 px-3 span-tertiary-state text-nowrap">
                <i class="fa fa-check color-tertiary mr-2" aria-hidden="true"></i> Adjudicada
            </span>
        </ng-container>
        <ng-container *ngSwitchCase="'Revocada'">
            <span class="py-2 px-3 span-error-state text-nowrap">
                <i class="fa fa-times-circle-o color-error mr-2" aria-hidden="true"></i> Revocada
            </span>
        </ng-container>
        <ng-container *ngSwitchCase="'Suspendida'">
            <span class="py-2 px-3 span-error-state text-nowrap">
                <i class="fa fa-times-circle-o color-error mr-2" aria-hidden="true"></i> Suspendida
            </span>
        </ng-container>
        <ng-container *ngSwitchDefault>
            <span class="py-2 px-3 span-other-state text-nowrap">
                {{elemento}}
            </span>
        </ng-container>
    </ng-container>
    
</ng-template>

<ng-template #estadoOrdenesTemplate let-elemento>

    <ng-container [ngSwitch]="elemento">
        <ng-container *ngSwitchCase="'Aceptada'">
            <span class="py-2 px-3 span-tertiary-state text-nowrap">
                <i class="fa fa-check color-tertiary mr-2" aria-hidden="true"></i> Aceptada
            </span>
        </ng-container>
        <ng-container *ngSwitchCase="'Recepcion Conforme'">
            <span class="py-2 px-3 span-tertiary-state text-nowrap">
                <i class="fa fa-check color-tertiary mr-2" aria-hidden="true"></i> Recepcion Conforme
            </span>
        </ng-container>
        <ng-container *ngSwitchCase="'Enviada a proveedor'">
            <span class="py-2 px-3 span-primary-state text-nowrap">
                <i class="fa fa-paper-plane-o color-primary mr-2 font-size-icon" aria-hidden="true"></i> Enviada a proveedor
            </span>
        </ng-container>
        <ng-container *ngSwitchCase="'En proceso'">
            <span class="py-2 px-3 span-primary-state text-nowrap">
                <i class="fa fa-clock-o color-primary mr-2 font-size-icon" aria-hidden="true"></i> En proceso
            </span>
        </ng-container>
        <ng-container *ngSwitchCase="'Cancelacion solicitada'">
            <span class="py-2 px-3 span-modif-state text-nowrap">
                <i class="fa fa-hourglass-half color-modif mr-2 font-size-icon" aria-hidden="true"></i> Cancelacion solicitada
            </span>
        </ng-container>
        <ng-container *ngSwitchCase="'Pendiente de Recepcionar'">
            <span class="py-2 px-3 span-modif-state text-nowrap">
                <i class="fa fa-hourglass-half color-modif mr-2 font-size-icon" aria-hidden="true"></i> Pendiente de Recepcionar
            </span>
        </ng-container>
        <ng-container *ngSwitchCase="'Recepcionada Parcialmente'">
            <span class="py-2 px-3 span-modif-state text-nowrap">
                <i class="fa fa-hourglass-half color-modif mr-2 font-size-icon" aria-hidden="true"></i> Recepcionada Parcialmente
            </span>
        </ng-container>
        <ng-container *ngSwitchCase="'Cancelada'">
            <span class="py-2 px-3 span-error-state text-nowrap">
                <i class="fa fa-times-circle-o color-error mr-2 font-size-icon" aria-hidden="true"></i> Cancelada
            </span>
        </ng-container>
        <ng-container *ngSwitchCase="'Recepcion Conforme Incompleta'">
            <span class="py-2 px-3 span-outline-state text-nowrap">
                <i class="fa fa-minus color-outline mr-2" aria-hidden="true"></i> Recepcion Conforme Incompleta
            </span>
        </ng-container>
        <ng-container *ngSwitchDefault>
            <span class="py-2 px-3 span-other-state text-nowrap">
                {{elemento}}
            </span>
        </ng-container>
    </ng-container>
    
</ng-template>
